// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import ElSalvador from '../_raw/flag/icon_flag_el_salvador.png';

export default () => <img src={ElSalvador} alt="ElSalvador" />;
